import { SITE_SURVEYS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/site_surveys_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator([
	'siteSurveysIndex',
	'siteSurveyScheduleWalkthrough',
	'woTasksCollection',
]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
